import { toPng } from 'html-to-image';

// Function to capture a screenshot of the entire page
async function captureScreenshot(domBody: HTMLElement): Promise<string> {
    const height = document.documentElement.scrollHeight;
    const width = document.documentElement.scrollWidth;

    // Collect all stylesheet rules
    const styles = Array.from(document.styleSheets)
        .map(styleSheet => {
            try {
                return Array.from(styleSheet.cssRules)
                    .map(rule => rule.cssText)
                    .join('');
            } catch (e) {
                // Error accessing stylesheet rules. Nothing we can do about it.
                return '';
            }
        })
        .join('\n');

    // Create a new style element with all the rules
    const styleElement = document.createElement('style');
    styleElement.textContent = styles;
    domBody.appendChild(styleElement);

    // Define the filter function to exclude specific elements
    const filter = (node: HTMLElement) => {
        const exclusionClasses = ['bf-nocapture']; // Add classes to exclude
        return !exclusionClasses.some((classname) => node.classList?.contains(classname));
    };

    // Capture the screenshot
    const image = await toPng(domBody, {
        quality: 0.7,               // Set quality to 0.7
        width,                    // Set width to the scroll width
        height,                   // Set height to the scroll height
        style: {
            transform: 'scale(1)', // Set scale to 1 to avoid scaling
        },
        skipFonts: true,          // Avoid embedding web fonts to bypass SecurityError
        cacheBust: true,          // Prevent caching
        backgroundColor: 'white', // Set background color to white
        fetchRequestInit: {
            mode: 'cors',          // Enable CORS
        },
        filter, 
        imagePlaceholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+P+/HgAFdwI2QJIhFwAAAABJRU5ErkJggg==', // Transparent placeholder for CORS-blocked images
    })

    // Remove the style element
    domBody.removeChild(styleElement);

    return image;
}

export { captureScreenshot };
